module.exports = __webpack_public_path__ + "img/Monte_Kope_95.3373eb06.jpg";